let cachedSnapshotPromise = null;

function determineEnvironment() {
  const host = window.location.hostname || "";
  if (host.includes(".dev2.")) return "dev2";
  if (host.includes(".dev.")) return "dev";
  if (host.includes(".qa.")) return "qa";
  if (host.includes("localhost")) return "local";
  if (host.includes(".umd.edu")) return "prod";
  return host || "web";
}

function parseOsInfo() {
  const userAgent = navigator.userAgent || "";

  if (/Windows NT 10\.0/.test(userAgent)) return { osName: "Windows", osVersion: "10" };
  if (/Windows NT 6\.3/.test(userAgent)) return { osName: "Windows", osVersion: "8.1" };
  if (/Windows NT 6\.2/.test(userAgent)) return { osName: "Windows", osVersion: "8" };
  if (/Windows NT 6\.1/.test(userAgent)) return { osName: "Windows", osVersion: "7" };

  const macMatch = userAgent.match(/Mac OS X ([0-9_]+)/);
  if (macMatch) return { osName: "macOS", osVersion: macMatch[1].replace(/_/g, ".") };

  const iosMatch = userAgent.match(/OS ([0-9_]+) like Mac OS X/);
  if (iosMatch) return { osName: "iOS", osVersion: iosMatch[1].replace(/_/g, ".") };

  const androidMatch = userAgent.match(/Android ([0-9.]+)/);
  if (androidMatch) return { osName: "Android", osVersion: androidMatch[1] };

  const linuxMatch = userAgent.match(/Linux ([^;)]*)/);
  if (linuxMatch) return { osName: "Linux", osVersion: linuxMatch[1] || "unknown" };

  return { osName: "Web", osVersion: "browser" };
}

function parseBrowserVersion() {
  const userAgent = navigator.userAgent || "";
  const patterns = [
    { name: "Edge", regex: /Edg\/([0-9.]+)/ },
    { name: "Chrome", regex: /Chrome\/([0-9.]+)/ },
    { name: "Firefox", regex: /Firefox\/([0-9.]+)/ },
    { name: "Safari", regex: /Version\/([0-9.]+).*Safari/ }
  ];

  for (const pattern of patterns) {
    const match = userAgent.match(pattern.regex);
    if (match) {
      return `${pattern.name} ${match[1]}`;
    }
  }

  return "browser";
}

async function loadVersionFile() {
  try {
    const url = new URL("../../VERSION", import.meta.url);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch VERSION: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    return { version: "unknown" };
  }
}

export async function getClientVersionSnapshot() {
  if (!cachedSnapshotPromise) {
    cachedSnapshotPromise = loadVersionFile().then((versionInfo) => {
      const { osName, osVersion } = parseOsInfo();
      return {
        service: "chatbot-ui",
        environment: determineEnvironment(),
        version: versionInfo.version || "unknown",
        osName,
        osVersion,
        runtime: "javascript",
        runtimeVersion: parseBrowserVersion(),
        reportedAt: new Date().toISOString()
      };
    });
  }

  return cachedSnapshotPromise;
}
